import { benefitsData } from '@/mocks/hoobuyData';

export default function BenefitsSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full border border-background-300 text-xs font-medium text-foreground-600 mb-4">
            Por que usar
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Por que usar um Hoobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Descubra as vantagens de usar nossa planilha organizada para suas compras
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {benefitsData.map((benefit, index) => (
            <div
              key={index}
              className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 transition-all"
            >
              <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                <i className={`${benefit.icon} text-lg text-primary-600`}></i>
              </span>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {benefit.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}